import { Col, Container, Row, Form, InputGroup, Image } from "react-bootstrap";
import React, { useState } from "react";
import { PatternFormat, NumericFormat } from "react-number-format"; // Importe os componentes
import "./NewFormular.css";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import useStore from "../../../Zustand/Zustand";
import ZustandValidationProponente from "../../../Zustand/ZustandFormProponent";

const NewFormular = (props) => {
  const {
    nomeCompletoProponente4,
    setNomeCompletoProponente4,
    nascimentoProponente4,
    setNascimentoProponente4,
    rendaMensalProponent4,
    setRendaMensalProponent4,
  } = useStore();

  const {
    nomeProponente,
    rendaProponente,
    nascimentoProponente,
    proponentErro,
    setNomeProponenteIsErro,
    nomeProponenteIsErro,
    nascimentoProponenteIsErro,
    rendaProponenteIsErro,
    setNascimentoProponenteIsErro,
    setRendaProponenteIsErro,
    setRendaProponente,
    setNomeProponente,
    setNascimentoProponente,
    setProponentErro,
  } = ZustandValidationProponente();

  const [proponentes, setProponentes] = useState([]);

  const addProponente = () => {
    setProponentes([
      ...proponentes,
      { nome: "", rendaMensal: "", nascimento: "" },
    ]);
  };

  useEffect(() => {
    if (nomeProponente.length > 1) {
      setNomeProponenteIsErro(false);
    }
  }, [nomeProponente]);

  useEffect(() => {
    if (rendaProponente >= 1000) {
      setRendaProponenteIsErro(false);
    }
  }, [rendaProponente]);

  useEffect(() => {
    if (nascimentoProponente.length > 1) {
      setNascimentoProponenteIsErro(false);
    }
  }, [nascimentoProponente]);

  function calcularIdadeTrueOrFalse(dataNascimento) {
    if (dataNascimento.length !== 8 || isNaN(dataNascimento)) {
      return false;
    }

    const dia = parseInt(dataNascimento.substring(0, 2), 10);
    const mes = parseInt(dataNascimento.substring(2, 4), 10);
    const ano = parseInt(dataNascimento.substring(4, 8), 10);

    const nascimento = new Date(ano, mes - 1, dia);
    const hoje = new Date();

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const diaAtual = hoje.getDate();

    if (mesAtual < mes || (mesAtual === mes && diaAtual < dia)) {
      idade--;
    }

    return idade >= 18 && idade <= 100;
  }
  const validateForm = () => {
    let count = 0;
    if (nomeProponente.length >= 10) {
      count++;
    } else {
      count--;
    }
    if (calcularIdadeTrueOrFalse(nascimentoProponente)) {
      count++;
    } else {
      count--;
    }
    if (rendaProponente >= 1000.0) {
      count++;
    } else {
      count--;
    }

    setProponentErro(count != 3);
  };
  useEffect(() => {
    validateForm();
  }, [nomeProponente, rendaProponente, nascimentoProponente]);

  const handleProponenteChange = (index, field, value) => {
    const updatedProponentes = [...proponentes];
    updatedProponentes[index][field] = value;
    setProponentes(updatedProponentes);
  };
  return (
    <section>
      <Container className="p-0">
        <Col className>
          <h1 className="title-proponente  ps-1">{props.name1}</h1>
          <Row className="ps-1">
            <Col xs={12} md={6} lg={4} className="mb-3">
              <Form.Label className="label">
                Nome Completo
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={nomeProponente}
                    onChange={(event) => {
                      const valor = event.target.value;
                      const valorFiltrado = valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
                      setNomeProponente(valorFiltrado);
                    }}
                  />
                </InputGroup>
                {((nomeProponente.length <= 10 && nomeProponente !== "") ||
                  nomeProponenteIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Digite o seu nome completo
                  </p>
                )}
              </Form.Label>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Label className="label">
                Renda Mensal
                <InputGroup>
                  <NumericFormat
                    className="form-control"
                    placeholder="R$ 0,00"
                    allowNegative={false}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    prefix="R$ "
                    value={rendaProponente}
                    onValueChange={(values) => setRendaProponente(values.value)}
                    customInput={Form.Control}
                  />
                </InputGroup>
                {((rendaProponente < 1000 && rendaProponente != 0) ||
                  rendaProponenteIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Renda inválida
                  </p>
                )}
              </Form.Label>
            </Col>

            <Col xs={12} sm={4} md={6} lg={4}>
              <Form.Label className="label">
                Nascimento
                <InputGroup>
                  <InputGroup.Text className="bg-white">
                    <CalendarDaysIcon
                      style={{
                        height: "24px",
                        width: "24px",
                        color: "rgba(0, 0, 0, 0.5)",
                      }}
                    />
                  </InputGroup.Text>
                  <PatternFormat
                    format="##/##/####"
                    placeholder="dd/mm/aaaa"
                    value={nascimentoProponente}
                    onValueChange={(values) =>
                      setNascimentoProponente(values.value)
                    }
                    customInput={Form.Control}
                    type="text"
                  />
                </InputGroup>
                {((nascimentoProponente.length <= 10 &&
                  !calcularIdadeTrueOrFalse(nascimentoProponente) &&
                  nascimentoProponente != "") ||
                  nascimentoProponenteIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1 ms-1"
                    style={{ fontSize: "12px" }}
                  >
                    Data inválida
                  </p>
                )}
              </Form.Label>
            </Col>
          </Row>
        </Col>

        {props.name2 ? (
          <Col>
            <h1 className="title-proponente ps-1">{props.name2}</h1>
            <Row className="ps-1">
              <Col xs={12} md={6} lg={4}>
                <Form.Label className="label">
                  Nome Completo
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder=""
                      value={nomeCompletoProponente4}
                      onChange={(event) => {
                        const valor = event.target.value;
                        const valorFiltrado = valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
                        setNomeCompletoProponente4(valorFiltrado);
                      }}
                    />
                  </InputGroup>
                </Form.Label>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <Form.Label className="label">
                  Renda Mensal
                  <InputGroup>
                    <NumericFormat
                      className="form-control"
                      placeholder="R$ 0,00"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      prefix="R$ "
                      value={rendaMensalProponent4}
                      onValueChange={(values) =>
                        setRendaMensalProponent4(values.value)
                      }
                      customInput={Form.Control}
                    />
                  </InputGroup>
                </Form.Label>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <Form.Label className="label">
                  Nascimento
                  <InputGroup>
                    <InputGroup.Text className="bg-white">
                      <CalendarDaysIcon
                        style={{
                          height: "24px",
                          width: "24px",
                          color: "rgba(0, 0, 0, 0.5)",
                        }}
                      />
                    </InputGroup.Text>
                    <PatternFormat
                      format="##/##/####"
                      placeholder="dd/mm/aaaa"
                      value={nascimentoProponente4}
                      onValueChange={(values) =>
                        setNascimentoProponente4(values.value)
                      }
                      customInput={Form.Control}
                      type="text"
                    />
                  </InputGroup>
                </Form.Label>
              </Col>

              {proponentes.map((proponente, index) => (
                <div key={index}>
                  <h1 className="title-proponente ps-1">
                    Proponente {index + 5}
                  </h1>
                  <Row className="ps-1">
                    <Col xs={12} md={6} lg={4}>
                      <Form.Label className="label">
                        Nome Completo
                        <InputGroup>
                          <Form.Control
                            type="text"
                            value={proponente.nome}
                            onChange={(event) => {
                              const valor = event.target.value;
                              const valorFiltrado = valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
                              handleProponenteChange(valorFiltrado);
                            }}
                          />
                        </InputGroup>
                      </Form.Label>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                      <Form.Label className="label">
                        Renda Mensal
                        <InputGroup>
                          <NumericFormat
                            className="form-control"
                            placeholder="R$ 0,00"
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale
                            prefix="R$ "
                            value={proponente.rendaMensal}
                            onValueChange={(values) =>
                              handleProponenteChange(
                                index,
                                "rendaMensal",
                                values.value
                              )
                            }
                            customInput={Form.Control}
                          />
                        </InputGroup>
                      </Form.Label>
                    </Col>

                    <Col xs={12} md={6} lg={4}>
                      <Form.Label className="label">
                        Nascimento
                        <InputGroup>
                          <InputGroup.Text className="bg-white">
                            <CalendarDaysIcon
                              style={{
                                height: "24px",
                                width: "24px",
                                color: "rgba(0, 0, 0, 0.5)",
                              }}
                            />
                          </InputGroup.Text>
                          <PatternFormat
                            format="##/##/####"
                            placeholder="dd/mm/aaaa"
                            value={nascimentoProponente4}
                            onValueChange={(values) =>
                              setNascimentoProponente4(values.value)
                            }
                            customInput={Form.Control}
                            type="text"
                          />
                        </InputGroup>
                      </Form.Label>
                    </Col>
                  </Row>
                </div>
              ))}

              <div className="pt-2"></div>
            </Row>
          </Col>
        ) : null}
      </Container>
    </section>
  );
};

export default NewFormular;
